import { c as _c } from "react/compiler-runtime";
import { VStack } from '@chakra-ui/react';
import { MemberSearchFilterForm } from '@src/components/sco/Members/MemberSearchFilterForm';
import { SidebarCollapsingNavList, SidebarCollapsingNavListItem } from '@src/components/sco/SidebarCollpasingNavList';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import React from 'react';
import { LuBookUser, LuUserCheck, LuUsers } from 'react-icons/lu';
type MembersNavProps = {};
export const membersNavSections: SidebarCollapsingNavListItem[] = [{
  icon: LuUsers,
  title: 'Member Matching',
  href: '/members/matching',
  nonActivePaths: ['/members/matching/saved']
}, {
  icon: LuUserCheck,
  title: 'Saved Matches',
  href: '/members/matching/saved',
  activeExact: true
}, {
  title: 'Founder Directory',
  icon: LuBookUser,
  href: `/founders`
}];
export const MembersNav = props => {
  const $ = _c(2);
  useActiveContentContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SidebarCollapsingNavList collapsed={true} defaultTitle="Members" items={membersNavSections} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <VStack align="stretch" height="full" justify="stretch" width="full">{t0}<SSRGate disableSSR={true}><MemberSearchFilterForm /></SSRGate></VStack>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};